<template>
    <div class="shopDetails">
        <div>
            <el-row>
                <el-col :span="18">
                    <div class="goods-info">
                        <div class="media" v-if="commodityDetails.itemPicture">
                            <GoodsImage :images="swiperList"></GoodsImage>
                        </div>
                        <div class="spec">
                            <div class="goods-sku">
                                <p class="clap">
                                    {{!commodityDetails.msg||commodityDetails.msg==' '?commodityDetails.title:commodityDetails.title+'·'+commodityDetails.msg}}
                                    <label class="origin" v-if="commodityDetails.price/1==0">面议</label>
                                </p>
                                <div class="rechargeItem">
                                    <div class="iponer" v-if="commodityDetails.price/1!=0">
                                        <p class="g-price">
                                            <span class="g-rena">意向价格</span>
                                            <span class="fz18 red fwB">¥</span>
                                            <span class="fz30 red fwB">
                                                {{commodityDetails.price}}
                                            </span>
                                            <span class="g-resa">
                                                /{{commodityDetails.priceUnited}}
                                            </span>
                                        </p>
                                        <p class="posasa">
                                            <!-- <i class="el-icon-magic-stick" style="color:#FFB71C;"></i>
                                            <span class="riesa">明标</span> -->
                                        </p>
                                        <p class="g-price" style="margin-top: 20px;">
                                            <span class="g-rena">底价</span>
                                            <span class=" blue fz18">
                                                ¥{{commodityDetails.price}}
                                            </span>
                                            <span class="g-resa" v-if="commodityDetails.price!='0'">
                                                /{{commodityDetails.priceUnited}}
                                            </span>
                                        </p>
                                    </div>
                                    <div class="iperssaa">
                                        <span v-if="commodityDetails.status == 1">进行中</span>
                                        <span v-if="commodityDetails.status == 2">停售中</span>
                                        <span v-if="commodityDetails.status == 3">已结束</span>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div class="container">
                                    <span class="item">
                                        <i class="i-colea">总量</i>
                                        <i
                                            class="i-coleasss">{{commodityDetails.amount}}{{commodityDetails.unitedTitle=="0"?"吨":"辆"}}</i>
                                    </span>
                                    <span class="item">
                                        <i class="i-colea">申买量</i>
                                        <i
                                            class="i-coleasss">{{commodityDetails.total|zero}}{{commodityDetails.unitedTitle=="0"?"吨":"辆"}}</i>
                                    </span>
                                    <span class="item">
                                        <i class="i-colea">最低销售量</i>
                                        <i
                                            class="i-coleasss">{{commodityDetails.totalAmount}}{{commodityDetails.unitedTitle=="0"?"吨":"辆"}}</i>
                                    </span>
                                    <span class="item">
                                        <i class="i-colea">浏览量</i>
                                        <i class="i-coleasss">{{commodityDetails.looktimes}}</i>
                                    </span>
                                    <span class="item">
                                        <i class="i-colea">交易量</i>
                                        <i
                                            class="i-coleasss">{{commodityDetails.total2|zero}}{{commodityDetails.unitedTitle=="0"?"吨":"辆"}}</i>
                                    </span>
                                </div>
                            </div>
                            <button class="xtx-button xtx-button2 ellipsis" v-if="commodityDetails.status!=3"
                                @click="selling(commodityDetails.status)">
                                {{sell}}
                            </button>
                            <button class="xtx-button xtx-button2 ellipsis" v-if="commodityDetails.status != 3"
                                @click="soldOut(commodityDetails.pricingDealsId)">
                                下架
                            </button>
                            <!-- <div>
                                <i class="el-icon-apple"></i>
                                <span class="shoucan">收藏产品</span>
                                <span class="shoucan">点击查看规则</span>
                            </div> -->
                        </div>
                    </div>
                </el-col>
                <el-col :span="6">
                    <ShopCompany></ShopCompany>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="18">
                    <div style=" margin-right: 60px;">
                        <div class="productDetail">
                            <div class="detailTabs">
                                <span :class="{compActive: currentComp === 'detailData' }"
                                    @click="clickSwitchTab(type = 'detailData')">意向订单</span>
                                <span :class="{compActive: currentComp === 'evaluation'}"
                                    @click="clickSwitchTab(type = 'evaluation')">产品详情</span>
                                <span :class="{compActive: currentComp === 'finalize'}"
                                    @click="clickSwitchTab(type = 'finalize')">完成订单</span>
                            </div>
                            <div class="detailBox clearfix">
                                <div class="detailInfoBox">
                                    <div v-show="currentComp==='detailData'">
                                        <div style="margin-top: 14px;"
                                            v-for="(intentionalOrder,index) in intentionalOrders" :key="index">
                                            <el-row>
                                                <el-col :span="24">
                                                    <div class="mokis">
                                                        <div>
                                                            <i class="el-icon-refresh origin"></i>
                                                            <span class="fz14 fwB origin">商议订单中</span>
                                                        </div>
                                                        <div>
                                                            <span class="fz14" style="margin-right: ;">
                                                                {{intentionalOrder.purchaseDate|time4}}
                                                            </span>
                                                            <span class="fz14">
                                                                <span
                                                                    class="fz16 fwB origin">¥{{intentionalOrder.unitPrice}}</span>/{{commodityDetails.priceUnited}}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </el-col>
                                                <el-col :span="24">
                                                    <div class="mokisas">
                                                        <span>{{intentionalOrder.companyName}}
                                                            {{intentionalOrder.name}}-交易员
                                                            {{intentionalOrder.purchaseDate|time3}}</span>
                                                        <span>交货周期{{intentionalOrder.begintime|time4}}至{{intentionalOrder.endtime|time4}}</span>
                                                        <span class="blue"
                                                            @click="openDes(intentionalOrder.pricingOrderId,1)"><i
                                                                class="el-icon-s-order"></i> 查看详情</span>
                                                    </div>
                                                </el-col>
                                                <el-col :span="24">
                                                    <el-row class="dassaf">
                                                        <el-col :span="11" class="mokiiua">
                                                            <span>意向价格
                                                                ¥{{intentionalOrder.unitPrice}}/{{commodityDetails.priceUnited}}</span>
                                                            <span>意向量
                                                                {{intentionalOrder.soldAmount}}/{{commodityDetails.unitedTitle=="0"?"吨":"辆"}}</span>
                                                        </el-col>
                                                        <el-col :span="13" class="mokiiua blue">
                                                            <span @click="shield(intentionalOrder.pricingOrderId,1)"><i
                                                                    class="el-icon-document-checked"></i>同意</span>
                                                            <span @click="shield(intentionalOrder.pricingOrderId,2)"><i
                                                                    class="el-icon-document-delete"></i>拒绝</span>
                                                            <span><i class="el-icon-phone-outline"></i>联系TA</span>
                                                            <span
                                                                @click="updataOrderShow([intentionalOrder.unitPrice,intentionalOrder.soldAmount,intentionalOrder.begintime,intentionalOrder.endtime,intentionalOrder.pricingOrderId])"><i
                                                                    class="el-icon-edit-outline"></i>修改</span>
                                                        </el-col>
                                                    </el-row>
                                                </el-col>
                                            </el-row>
                                        </div>
                                    </div>
                                    <div v-show="currentComp==='evaluation'">
                                        <!-- 产品详情 -->
                                        <div>
                                            <div class="evaluation-box">
                                                <div>
                                                    <div>交货方式</div>
                                                    <div>{{commodityDetails.deliveryMethod}}</div>
                                                </div>
                                                <div>
                                                    <div>付款方式</div>
                                                    <div>{{commodityDetails.paymentMethod}}</div>
                                                </div>
                                                <div>
                                                    <div>货物品质</div>
                                                    <div>
                                                        <span
                                                            v-show="productNameJC(commodityDetails.title)">{{commodityDetails.description}}</span>
                                                        <span v-show="!productNameJC(commodityDetails.title)">
                                                            {{commodityDetails.domestic}}
                                                            {{commodityDetails.qualityOfGoods}}
                                                            {{commodityDetails.qualityOfGoodsOne}}
                                                            {{commodityDetails.itemCharacteristics==null||commodityDetails.itemCharacteristics==""?" ":"乙醇含量低于"+commodityDetails.itemCharacteristics+"单位PPM "}}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div>
                                                    <div>最低销售量</div>
                                                    <div>
                                                        {{commodityDetails.totalAmount }}{{commodityDetails.unitedTitle=="0"?"吨":"辆"}}
                                                    </div>
                                                </div>
                                                <div>
                                                    <div>总量</div>
                                                    <div>{{commodityDetails.amount}}
                                                        {{commodityDetails.unitedTitle=="0"?"吨":"辆"}}
                                                    </div>
                                                </div>
                                                <div>
                                                    <div>意向价</div>
                                                    <div v-if="commodityDetails.price=='0'">面议</div>
                                                    <div v-else>{{commodityDetails.price}}元/{{commodityDetails.priceUnited}}
                                                    </div>
                                                </div>
                                                <div>
                                                    <div>交货周期</div>
                                                    <div>{{commodityDetails.deliveryCycle}}天</div>
                                                </div>
                                                <div>
                                                    <div>交割地</div>
                                                    <div>
                                                        {{commodityDetails.location}}
                                                    </div>
                                                </div>
                                                <div>
                                                    <div>商品描述</div>
                                                    <div>{{commodityDetails.details}}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-show="currentComp==='finalize'">
                                        <div style="margin-top: 14px;" v-for="(finishOrder,index) in finishOrders"
                                            :key="index">
                                            <el-row>
                                                <el-col :span="24">
                                                    <div class="mokis mokis2">
                                                        <div>
                                                            <i class="el-icon-circle-check green"></i>
                                                            <span class="fz14 fwB green">已同意订单</span>
                                                        </div>
                                                        <div>
                                                            <span class="fz14" style="margin-right: ;">
                                                                {{finishOrder.purchaseDate|time4}}
                                                            </span>
                                                            <span class="fz14">
                                                                <span
                                                                    class="fz16 fwB green">¥{{finishOrder.unitPrice}}</span>/{{commodityDetails.priceUnited}}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </el-col>
                                                <el-col :span="24">
                                                    <div class="mokisas">
                                                        <span>{{finishOrder.companyName}}
                                                            {{finishOrder.name}}-交易员
                                                            {{finishOrder.purchaseDate|time3}}</span>
                                                        <span>交货周期{{finishOrder.begintime|time4}}至{{finishOrder.endtime|time4}}</span>
                                                        <span class="blue"
                                                            @click="openDes(finishOrder.pricingOrderId,1)"><i
                                                                class="el-icon-s-order"></i> 查看详情</span>
                                                    </div>
                                                </el-col>
                                                <el-col :span="24">
                                                    <el-row class="dassaf">
                                                        <el-col :span="11" class="mokiiua">
                                                            <span>成交价格
                                                                ¥{{finishOrder.oldPrice}}/{{finishOrder.priceUnited}}</span>
                                                            <span>成交量
                                                                {{finishOrder.oldAmount}}/{{finishOrder.unitedTitle=="0"?"吨":"辆"}}</span>
                                                        </el-col>
                                                        <el-col :span="13" class="mokiiua blue">
                                                        </el-col>
                                                    </el-row>
                                                </el-col>
                                            </el-row>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-col>
                <!-- <el-col :span="6">
                    <span>推荐产品</span>
                    <commodityDetails></commodityDetails>
                </el-col> -->
            </el-row>
        </div>
        <div class="mark" v-show="popupVisible"></div>
        <div class="pup" v-show="popupVisible">
            <div @click="popupVisible=false">X</div>
            <div>{{commodityDetails.title}}</div>
            <div>
                <div>
                    意向价
                </div>
                <div>
                    <el-input size="small" placeholder="请输入价格" v-model="yxprice" @input="clickOfferAPrice">
                    </el-input>
                </div>
            </div>
            <div>
                <div>
                    意向量
                </div>
                <div>
                    <el-input size="small" placeholder="请输入价格" v-model="yxnum" @input="clickOfferAPrice">
                    </el-input>
                </div>
            </div>
            <div class="date">
                <div>交货周期</div>
                <div>
                    <el-date-picker size="small" v-model="deliveryTime.start" type="date" placeholder="选择日期时间">
                    </el-date-picker>
                    <span>至</span>
                    <el-date-picker size="small" v-model="deliveryTime.end" type="date" placeholder="选择日期时间">
                    </el-date-picker>
                </div>
            </div>
            <div @click="updataOrder">确定</div>
        </div>
        <div class="mark" v-show="popupVisiblePrice"></div>
        <div class="pup" v-show="popupVisiblePrice">
            <div @click="popupVisiblePrice=false">X</div>
            <div>{{commodityDetails.title}}</div>
            <div>
                <div>
                    意向价
                </div>
                <div>
                    <el-input size="small" placeholder="请输入价格" v-model="xiugaiPric">
                    </el-input>
                </div>
            </div>
            <div>
                <div>
                    意向量
                </div>
                <div>
                    <el-input size="small" placeholder="请输入价格" v-model="xiugaiNum">
                    </el-input>
                </div>
            </div>
            <div class="red">在变更价格前请确认当前价格下是否有议价单</div>
            <div @click="srueChange(commodityDetails.pricingDealsId,commodityDetails.status)">确认变更</div>
        </div>
    </div>

</template>
<script>
    import commodityDetails from '../commodity'
    import GoodsImage from "../goods-image.vue"
    import intesaTask from "../goods-sku.vue";

    import ShopCompany from "../../components/ShopCompany.vue"
    export default {
        data() {
            return {
                swiperList: [],
                currentComp: 'detailData', //显示的内容，默认显示详情
                activeName: 'second',



                commodityId: '', //商品Id
                commodityDetails: '', //商品详情
                quantity: 0, //数量
                aggregate: 0, //总价
                fixedType: false,
                offerAPrice: 0, //购买价
                intentionalOrders: [], //意向订单列表
                finishOrders: [], //意向完成订单
                revokeOrderId: '',
                tabSwitchNum: 0,
                yxprice: '',
                yxnum: '',
                deliveryTime: {
                    start: '',
                    end: ''
                },
                orderId: '',
                popupVisible: false,
                date: false,
                dateVal: new Date(),
                agent2: '',
                sell: '',
                xiugaiPric: '',
                xiugaiNum: '',
                popupVisiblePrice: false,
                rotateType: false,

                confirmShow: false
            };
        },
        filters: {
            zero: function(v) {
                if (v == null || v == '' || v == 'null') {
                    return '0';
                } else {
                    return v;
                }
            },
            //获取年月日
            time4: function(v) {

                function changeNum(num) {
                    return num = num < 10 ? "0" + num : num;
                }
                var time = new Date(v);
                return changeNum(time.getFullYear()) +
                    "-" + changeNum(time.getMonth() + 1) +
                    "-" + changeNum(time.getDate());
            },
            //获取十分
            time3: function(v) {
                function changeNum(num) {
                    return num = num < 10 ? "0" + num : num;
                }
                var time = new Date(v);
                return changeNum(time.getHours()) +
                    ":" + changeNum(time.getMinutes());
            },
        },
        components: {
            commodityDetails,
            GoodsImage,
            intesaTask,
            ShopCompany
        },
        mounted() {
            let that = this;
            that.commodityId = that.$route.query.commodityId;
            that.getyxCommodityDetails();
            that.getyxViewOrder(that.$store.state.userId, that.commodityId, 0);
            that.getyxViewOrder(that.$store.state.userId, that.commodityId, 1);
        },
        methods: {
            srueChange: function(id, state) {
                var sellData = {};
                sellData = {
                    pricingDealsId: id,
                    Status: '1',
                    price: this.xiugaiPric,
                    amount: this.xiugaiNum
                }
                this.haltSalesUrl(sellData, state);
            },
            haltSalesUrl: function(dataObj, state) {
                var that = this;
                var prompt = state == '1' ? '停售' : '开始销售';
                that.request({
                    method: 'post',
                    url: that.$store.state.httpUrl + "intentional/haltSales",
                    params: dataObj
                }).then(res => {
                    if (res.status == 200) {
                        that.popupVisiblePrice = false;
                        that.getyxCommodityDetails();
                    }
                });
            },
            stopSellClick: function(id, state) {
                if (state == '1') {
                    var sellData = {};
                    sellData = {
                        pricingDealsId: id,
                        Status: '2'
                    }
                    this.haltSalesUrl(sellData, state);
                } else if (state == '2') {
                    if (this.intentionalOrders.length != 0) {
                        this.$message({
                            message: '有未完成订单，请先完成订单',
                            type: 'warning'
                        });
                        return false;
                    } else {
                        this.popupVisiblePrice = true;
                    }
                }
            },
            //下架
            soldOut: function(id) {
                var that = this;
                that.$confirm('您好，确认是否下架？', '下架提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    that.request({
                        method: 'post',
                        url: this.$store.state.httpUrl + "intentional/haltSales",
                        params: {
                            pricingDealsId: id,
                            Status: 3
                        },
                    }).then(res => {
                        if (res.status == 200) {
                            that.$message({
                                message: '下架成功',
                                type: 'success'
                            });
                            that.getyxCommodityDetails();
                        }
                    }).catch(() => {});;
                }).catch(() => {});
            },
            //停\开售
            selling: function(state) {
                let that = this;
                that.xiugaiPric = that.commodityDetails.price;
                that.xiugaiNum = that.commodityDetails.amount;
                let prompt = state == '1' ? '停售' : '开始销售';
                that.$confirm('您好，确认是否' + prompt + "？", prompt + '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    that.stopSellClick(that.commodityDetails.pricingDealsId, that.commodityDetails.status);
                }).catch(() => {});
            },
            timeType: function(v) {
                function changeNum(num) {
                    return num = num < 10 ? "0" + num : num;
                }
                let time = new Date(v);
                return changeNum(time.getFullYear()) +
                    "-" + changeNum(time.getMonth() + 1) +
                    "-" + changeNum(time.getDate());
            },
            //修改订单
            updataOrder: function() {
                let that = this;
                let modifyData = {};
                let startTimes = that.timeType(that.deliveryTime.start);
                let endTimes = that.timeType(that.deliveryTime.end);

                modifyData = {
                    price: that.yxprice,
                    amount: that.yxnum,
                    userId: that.$store.state.userId,
                    intentionalSaleId: that.orderId,
                    beginTime: startTimes + ' 00:00:00',
                    endTime: endTimes + ' 00:00:00'
                }

                let startSecond = new Date(Date.parse(startTimes));
                let endSecond = new Date(Date.parse(endTimes));
                if (startSecond > endSecond) {
                    this.$message({
                        message: '开始时间大于结束时间，请重新选择',
                        type: 'warning'
                    });
                    return false;
                };
                that.$confirm('您好，是否确认修改订单?', '修改订单提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    that.request({
                        method: 'post',
                        url: this.$store.state.httpUrl + "intentional/isTrue",
                        params: {
                            id: that.orderId
                        },
                    }).then(res => {
                        if (res.status == 200) {
                            if (res.data.status == '0') {
                                that.request({
                                    method: 'post',
                                    url: that.$store.state.httpUrl + "intentional/process",
                                    params: modifyData
                                }).then(res => {
                                    if (res.status == 200) {
                                        that.getyxViewOrder(that.$store
                                            .state.userId, that
                                            .commodityId, 0);
                                        that.getyxViewOrder(that.$store
                                            .state.userId, that
                                            .commodityId, 1);
                                        that.popupVisible = false;
                                    }
                                });
                            }
                        }
                    }).catch(() => {});;
                })
            },
            //修改订单信息
            updataOrderShow: function(e) {
                this.yxprice = e[0];
                this.yxnum = e[1];
                this.deliveryTime.start = e[2];
                this.deliveryTime.end = e[3];
                this.orderId = e[4];
                this.popupVisible = true;
            },
            //订单详情页面
            openDes: function(pricingOrderId, sellerOrder) {
                var that = this;
                that.$router.push({
                    path: '/order_yxmh',
                    query: {
                        orderId: pricingOrderId,
                        sellerOrder: sellerOrder
                    }
                });

            },
            //同意订单&&拒绝订单  status ：1 是同意 ，2是拒绝
            shield: function(id, status) {
                let that = this;
                that.$confirm(status == 1 ? '是否同意参与方提出的要求' : '是否拒绝参与方提出的要求', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    that.intentionOrderAffirm(id, status);
                }).catch(() => {});
            },
            intentionOrderAffirm: function(orderid, status) {
                let that = this;
                that.request({
                    method: 'post',
                    url: that.$store.state.httpUrl + "intentional/isTrue",
                    params: {
                        id: orderid
                    }
                }).then(res => {
                    if (res.status == 200) {
                        if (res.data.status == '0') {
                            that.request({
                                method: 'post',
                                url: that.$store.state.httpUrl + "intentional/orderStatus",
                                params: {
                                    pricingOrderId: orderid,
                                    status: status
                                }
                            }).then(res => {
                                if (res.status == 200) {
                                    that.getyxViewOrder(that.$store.state.userId, that.commodityId,
                                        0);
                                    that.getyxViewOrder(that.$store.state.userId, that.commodityId,
                                        1);
                                }
                            });
                        }
                    }
                });
            },
            //确认购买
            confirmOfferAPriceFn: function() {
                let that = this;
                this.request.get(this.$store.state.httpUrl + "userDetails/findUserPerson", {
                    params: {
                        id: that.$store.state.userId,
                        flag: that.$store.state.isPerson
                    }
                }).then(res => {
                    if (res.status == 200) {
                        if (res.data.isNotCertified != '2') {
                            that.$confirm('您好，您还没有认证，暂时不能操作，是否去认证?', '认证提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(() => {
                                that.$router.push({
                                    path: '/authentication',
                                    query: {

                                    }
                                });
                            }).catch(() => {});
                        } else {
                            that.nextStep();
                        }
                    }
                });
            },
            nextStep() {
                let that = this;

                this.request.get(this.$store.state.httpUrl + "intentional/purchase", {
                    params: {
                        pricingDealsId: that.commodityId,
                        companyId: that.$store.state.userId,
                        soldAmount: that.quantity,
                        unitPrice: that.offerAPrice,
                        productId: that.commodityDetails.productId
                    }
                }).then(res => {
                    if (res.status == 200) {
                        that.isOfferAPrice = false;
                        that.isConfirmOfferAPrice = false;
                        that.quantity = that.commodityDetails.totalAmount;
                        that.getyxViewOrder(that.$store.state.userId, that.commodityId, 0);
                        that.offerAPrice = that.commodityDetails.price;
                    }
                });
            },
            //取消购买
            cancelOfferAPriceFn: function() {
                var that = this;
                that.isOfferAPrice = false;
                that.isConfirmOfferAPrice = false;
                that.quantity = that.commodityDetails.totalAmount;
                that.offerAPrice = that.commodityDetails.price;
            },
            quantityChange: function(e) {
                var that = this;
                var dom = e.currentTarget;
                if (dom.value.length == 1) {
                    dom.value = dom.value.replace(/[^1-9]/g, '')
                } else {
                    dom.value = dom.value.replace(/\D/g, '')
                }
                that.quantity = dom.value;
                that.aggregate = that.mul(that.offerAPrice, that.quantity);
            },
            //改变数量
            quantityChangeFn: function(str) {
                var that = this;
                if (str == 'add') {
                    if (that.commodityDetails.title == '甲醇') {
                        // console.log(that.quantity)
                        if (that.sub(that.quantity, 10) < (that.commodityDetails.amount - 10)) {
                            that.quantity = that.add(that.quantity, 10);
                        }

                    } else {
                        if (that.sub(that.quantity, 1) < (that.commodityDetails.amount - 1)) {
                            that.quantity = that.add(that.quantity, 1);
                        }
                    }
                }
                if (str == 'sub') {
                    if (that.commodityDetails.title == '甲醇') {
                        console.log(that.commodityDetails.totalAmount)
                        if (that.sub(that.quantity, 10) > (that.commodityDetails.totalAmount - 10)) {
                            that.quantity = that.sub(that.quantity, 10);
                        }

                    } else {
                        if (that.sub(that.quantity, 1) > (that.commodityDetails.totalAmount - 1)) {
                            that.quantity = that.sub(that.quantity, 1);
                        }
                    }
                    if (that.quantity <= that.commodityDetails.startingVolume) {
                        that.quantity = that.commodityDetails.startingVolume;
                    }
                }
                that.aggregate = that.mul(that.offerAPrice, that.quantity);
            },
            clickOfferAPrice: function() {
                var that = this;
                that.aggregate = that.mul(that.offerAPrice, that.quantity);
            },
            //参与购买
            offerAPriceFn: function() {
                var that = this
                that.isOfferAPrice = !that.isOfferAPrice;
                that.aggregate = that.mul(that.offerAPrice, that.quantity);
            },
            getyxCommodityDetails(str) {
                let that = this;
                this.request.get(this.$store.state.httpUrl + "intentional/findInfo", {
                    params: {
                        id: that.commodityId,
                        commodityType: 'P',
                        userId: that.$store.state.userId
                    }
                }).then(res => {
                    if (res.status == 200) {
                        //获取商品详情
                        that.commodityDetails = res.data;
                        that.quantity = res.data.totalAmount;
                        that.offerAPrice = res.data.price;
                        if (res.data.state == '1') {
                            that.sell = '停售';
                        } else if (res.data.status == '2') {
                            that.sell = '开始销售';
                        } else {
                            that.sell = '停售';
                        }
                        that.swiperList = [];
                        that.swiperList.push(res.data.itemPicture);
                    }
                });
            },
            getyxViewOrder(userId, id, status) {
                let that = this;
                this.request.get(this.$store.state.httpUrl + "intentional/viewOrder", {
                    params: {
                        companyId: userId,
                        pricingDealsId: id,
                        status: status
                    }
                }).then(res => {
                    if (res.status == 200) {
                        if (status == 0) {
                            that.intentionalOrders = '';
                            that.intentionalOrders = res.data;
                        } else {
                            that.finishOrders = '';
                            that.finishOrders = res.data;
                        }
                        that.tabSwitchNum = that.intentionalOrders.length > 0 ? 0 : 2;
                    }
                });
            },
            clickSwitchTab(type) {
                this.currentComp = type
            },
        }
    };
</script>
<style lang="less" scoped>
    .shopDetails {
        background: #FFFFFF;
        padding-bottom: 50px;
    }

    .shopDetails>div {
        width: 1200px;
        margin: 0 auto;
    }

    .goods-info {
        min-height: 430px;
        background: #fff;
        display: flex;

        .media {
            width: 280px;
            height: 320px;
            padding: 30px 50px 30px 0px;
        }

        .spec {
            width: calc(100% - 320px);
            padding: 30px 65px 30px 0;
            text-align: left;
            box-sizing: border-box;
        }
    }

    /deep/ .el-tabs__header {
        margin: 0;
    }

    /deep/ .el-tab-pane {
        background: #ffffff;
    }

    /deep/ .el-tabs__content {
        background: #ffffff;
        padding-top: 15px;
    }

    .xtx-button {
        appearance: none;
        border: none;
        outline: none;
        background: #fff;
        text-align: center;
        border: 1px solid transparent;
        border-radius: 4px;
        cursor: pointer;
        background: #D70606;
        color: #fff;
        border-radius: 10px;
        width: 180px;
        height: 50px;
        font-size: 16px;
        margin-top: 24px;
        margin-bottom: 24px;
    }

    .xtx-button2 {
        background: #CFDEFF;
        color: #D70606;
    }

    .shoucan {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #999999;
        line-height: 28px;
    }

    .i-colea {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #999999;
        line-height: 28px;
    }

    .gongsi {
        font-size: 14px;
        color: #333333;
        line-height: 28px;
    }

    .borearss {
        width: 48px;
        height: 48px;
        border-radius: 50%;
        margin: 0 auto;
        margin-top: 10px;
        margin-bottom: 30px;
    }

    .borearss>img {
        width: 48px;
        height: 48px;
        background: #D70606;
        border-radius: 50%;
    }

    .moiuysa {
        background: #FFFFFF;
        border: 1px solid #D70606;
        border-radius: 8px;
        text-align: center;
        margin-top: 25px;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #D70606;
        line-height: 28px;
    }

    .xian {
        border-bottom: 1px solid #CCCCCC;
        margin-top: 20px;
        margin-bottom: 20px;
    }

    .moaksa {
        display: flex;
    }

    .siaosaf {
        font-size: 14px;
        color: #999999;
        line-height: 28px;
    }

    .anniu {
        background: #FEB960;
        border: none;
    }

    .siaosaf-q {
        margin-left: 22px;
        background: #FEB960;
        border-radius: 4px;
        font-size: 14px;
        color: #FFFFFF;
    }

    .mokisa {
        margin-left: 10px;
        font-size: 14px;
    }

    .bang-rigth {
        width: 260px;
        background: #FFFFFF;
        border: 1px solid #ABC0EC;
        border-radius: 10px;
        margin: 0 auto;
        padding: 20px;
        text-align: left;
    }

    .i-coleasss {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        line-height: 28px;
    }

    .container {
        display: flex;
        flex-wrap: wrap;
        text-align: center;
        border-bottom: 1px solid #CCCCCC;
        padding-bottom: 10px;
    }

    .container>.item {
        width: 33.33%;
    }

    .displa {
        display: flex;
        flex-direction: column;
        align-items: left;
    }

    .evaluation-box {
        padding-top: 20px;

        div {
            display: flex;
            font-size: 14px;
            text-align: left;
            color: #333333;
            margin-bottom: 8px;
            line-height: 24px;
        }
    }

    .evaluation-box>div>div:nth-child(1) {
        width: 100px;
        color: #999999;
    }

    .productDetail {
        .detailTabs {
            height: 46px;
            line-height: 46px;
            border-bottom: 2px solid #D70606;
            display: flex;

            span {
                padding: 0 30px;
                cursor: pointer;
                color: #333333;
                font-size: 16px;
            }

            .compActive {
                background: #D70606;
                color: #ffffff;
            }
        }
    }

    .mokis {
        background: #FFE8D6;
        padding: 17px 30px;
        display: flex;
        justify-content: space-between;
    }

    .mokis2 {
        background: #EAF8F0;
    }

    .mokisas {
        padding: 16px 30px;
        display: flex;
        justify-content: space-between;
        border: 1px solid #EBEEF5;
    }

    .mokiiua span,
    .mokisas span {
        font-size: 14px;
        cursor: pointer;
        margin-left: 40px;
    }

    .mokiiua {
        display: flex;
        padding: 16px 0px;
    }

    .dassaf {
        border: 1px solid #EBEEF5;
        padding: 0 30px;
        border-top: none;
    }

    .dassaf>div:nth-child(2) {
        justify-content: flex-end;
    }

    .goods-sku {
        .clap {
            font-size: 20px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #333333;
            text-align: left;
        }

        .g-resa {

            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #666666;
        }

        .iponer {
            position: relative;
            background: #F2F6FF;
            color: #ffffff;
            position: relative;
            padding: 20px;

            .posasa {
                position: absolute;
                right: 32px;
                top: 22px;

                .riesa {
                    font-size: 14px;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: #333333;
                    line-height: 28px;
                }
            }

            .g-price {
                .g-rena {
                    display: inline-block;
                    width: 80px;
                    text-align: right;
                    font-size: 14px;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: #666666;
                }
            }
        }

        .rechargeItem {
            overflow: hidden;
            border-radius: 20px;
            margin-bottom: 20px;
            margin-top: 18px;
        }

        .iperssaa {
            background: #DDECFA;
            cursor: pointer;
            padding: 0 20px;
            height: 40px;
            line-height: 40px;
            text-align: left;
            font-size: 14px;
            color: #666666;

            .miaosha {
                font-size: 18px;
                font-weight: bold;
                color: #3166D6;
                margin-left: 20px;
            }

            .iperssaa_over {
                display: block;
                text-align: center;
            }
        }
    }

    /deep/.el-tabs--top {
        margin: 0 auto;
    }

    /deep/.mokis {
        margin: 0 auto;
    }

    /deep/ .el-tabs__nav {
        width: 1200px;
        margin: 0 auto;
    }

    /deep/ .el-tabs__active-bar {
        background-color: transparent !important;
    }

    /deep/ .el-table__body tr.current-row>td {
        background-color: #add8e6 !important;
    }

    /*去掉tabs底部的下划线*/
    /deep/ .el-tabs__nav-wrap::after {
        position: static !important;
    }

    /deep/.el-tabs__nav-scroll {
        background-color: #D70606;
    }

    /deep/.el-tabs__item.is-active {
        color: #FFFFFF;
    }

    /deep/ .el-tabs__item {
        color: #81AAFF;
    }

    .rechargeItemTop {
        background: #F2F6FF;
        color: #ffffff;
        position: relative;
        padding: 20px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        border: 1px solid #CCDDFF;
    }

    .shopDetails>.pup {
        position: fixed;
        width: 460px;
        height: 310px;
        background: #FFFFFF;
        box-shadow: 0px 1px 7px 0px rgba(58, 138, 250, 0.35);
        box-sizing: border-box;
        border-radius: 15px;
        top: 380px;
        left: calc(50% - 230px);
    }

    .mark {
        position: fixed;
        left: 0;
        top: 0;
        width: 100% !important;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
    }

    .pup>div {
        padding: 0 20px;
        margin-top: 18px;
        display: flex;
        justify-content: space-between;
    }

    .pup div,
    .pup span {
        font-size: 14px;
    }

    .pup>div>div:nth-child(1),
    .pup>div>div:nth-child(2) {
        width: 80px;
        text-align: right;
        color: #999999;
    }

    .pup>div:nth-child(1) {
        display: block;
        text-align: right;
        height: 36px;
        line-height: 36px;
        color: #FFFFFF;
        background: #6698FE;
        border-radius: 15px 15px 0 0;
        margin-top: 0;
    }

    .pup>div:nth-child(2) {
        font-size: 18px;
        font-weight: bold;
        color: #333333;
    }

    .pup>div:nth-child(3) {}

    .pup>div:nth-child(3)>div:nth-child(1),
    .pup>div:nth-child(4)>div:nth-child(1),
    .pup>.date>div:nth-child(1) {
        width: 80px;
        text-align: right;
        color: #999999;
        padding-right: 20px;
        box-sizing: border-box;
        line-height: 32px;
    }

    .pup>div:nth-child(3)>div:nth-child(2),
    .pup>div:nth-child(4)>div:nth-child(2),
    .pup>.date>div:nth-child(2) {
        width: calc(100% - 80px);
        line-height: 32px;
    }

    .pup>.date>div:nth-child(2) {
        display: flex;
    }

    .pup>.date>div:nth-child(2)>span {
        display: block;
        width: 60px;
        text-align: center;
    }

    .pup>div:last-child {
        width: 230px;
        height: 40px;
        line-height: 40px;
        background: #6698FE;
        border-radius: 5px;
        color: #FFFFFF;
        cursor: pointer;
        margin: 0 auto;
        margin-top: 18px;
        display: block;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/view/shop/shopYxmhDetailsSell.vue